// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"50":"datadogProfiler","133":"datadogRecorder"}[chunkId] || chunkId) + "." + {"50":"80a42d89","133":"99777745","787":"e8d17bb7"}[chunkId] + ".chunk.js";
};